// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-header {
  margin-bottom: 20px;
}

.skl-card {
  margin-bottom: 16px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(140px, 1fr) minmax(160px, 1fr);
  gap: 16px;
  align-items: end;
}

.skl-form-grid__action {
  display: flex;
  align-items: end;
}

@media (max-width: 767.98px) {
  .skl-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/pods-list/pods-list-skeleton/pods-list-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,2EAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;AACF","sourcesContent":[".skl-header {\n  margin-bottom: 20px;\n}\n\n.skl-card {\n  margin-bottom: 16px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-form-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(140px, 1fr) minmax(160px, 1fr);\n  gap: 16px;\n  align-items: end;\n}\n\n.skl-form-grid__action {\n  display: flex;\n  align-items: end;\n}\n\n@media (max-width: 767.98px) {\n  .skl-form-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
